import _toConsumableArray from "D:\\\u0420\u0410\u0411\u041E\u0422\u0410\\\u041F\u0420\u041E\u0415\u041A\u0422\u042B\\amio new\\new.amio_hub\\dev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
export default function removeClasses() {
  var _el$classList;
  var swiper = this;
  var el = swiper.el,
    classNames = swiper.classNames;
  (_el$classList = el.classList).remove.apply(_el$classList, _toConsumableArray(classNames));
  swiper.emitContainerClasses();
}